import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Colors, View } from "react-native-ui-lib";
import { Label } from "@towersystems/roam-common-native";
import { ProductFormValues, FormInputProps } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";
import Editor from "react-simple-wysiwyg";
import { LllmQuickWinButton } from "../../../../../../components/LlmQuickWinButton";
import { useLlmQuickWinsProvider } from "../../../../../../utilities/llm-quick-wins";

export type DescriptionFormInputProps = FormInputProps & {
  onLlmQuickWinButtonPress?: () => void;
};

const RichTextEditor = ({
  disabled,
  onContentChange,
  value = "",
}: {
  disabled?: boolean;
  onContentChange: (t: any) => void;
  value: string;
}) => {
  return (
    <View>
      <View
        style={{
          borderWidth: 1,
          borderColor: Colors.inputBorderColor,
          borderBottomWidth: 0,
          backgroundColor: Colors.input,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
        }}
      ></View>

      <View
        style={{
          borderWidth: 1,
          borderColor: Colors.inputBorderColor,
          borderBottomEndRadius: 4,
          borderBottomStartRadius: 4,
          backgroundColor: Colors.input,
        }}
      >
        <Editor
          style={{
            height: 200,
          }}
          disabled={disabled}
          value={value}
          onChange={onContentChange}
        />
      </View>
    </View>
  );
};

export const DescriptionFormInput = ({
  onLlmQuickWinButtonPress,
}: DescriptionFormInputProps) => {
  const { control, watch } = useFormContext<ProductFormValues>();
  const { t } = useTranslation("product");
  const globalDisable = useWatch({ control, name: "globalDisable" });
  const nameValue = watch("name");
  const { strategyEnabled } = useLlmQuickWinsProvider();

  return (
    <View style={{ position: "relative" }}>
      <Label label={t("form.description.label")}>
        {onLlmQuickWinButtonPress &&
        strategyEnabled("product_description_quick_win") ? (
          <View style={{ marginLeft: 8 }}>
            <LllmQuickWinButton
              onPress={onLlmQuickWinButtonPress}
              disabled={!nameValue}
              hoverText="Generate Description with AI"
            />
          </View>
        ) : null}
      </Label>
      <Controller
        name="description"
        control={control}
        disabled={globalDisable}
        render={({
          field: { onChange, value, disabled },
          fieldState: { error },
        }) => (
          <RichTextEditor
            onContentChange={onChange}
            value={value}
            disabled={disabled}
          />
        )}
      />
    </View>
  );
};
